import { useEffect } from "react";
import { createPortal } from "react-dom";
import { SUPPORT_SIZES, supportHref } from "../lib/support.js";

function BeerIcon({ size }: { size: "small" | "medium" | "large" }) {
  return (
    <svg className={`support-amount__icon support-amount__icon--${size}`} viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M8.2 4.1h7.1c.85 0 1.35.85 1 1.6L16 7.1H7.7l-.3-1.4c-.35-.75.15-1.6 1-1.6zM7 7.6h9.5v9.05A3.2 3.2 0 0 1 13.3 19.85h-3.1A3.2 3.2 0 0 1 7 16.65V7.6zm9.5 1.45h2.15a2.2 2.2 0 0 1 0 4.4H16.5V9.05z"
      />
    </svg>
  );
}

export function SupportDialog({ onClose }: { onClose: () => void }) {
  useEffect(() => {
    function onKey(event: KeyboardEvent) {
      if (event.code === "Escape") onClose();
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return createPortal(
    <div className="bug-overlay" role="dialog" aria-modal="true" aria-labelledby="support-title" onClick={onClose}>
      <div className="bug-card support-card" onClick={(event) => event.stopPropagation()}>
        <p className="bug-card__kicker">Wesprzyj</p>
        <h2 className="bug-card__title" id="support-title">
          Postaw piwo Norbertowi
        </h2>
        <p className="bug-card__copy">
          zioło.eu jest bez reklam i utrzymuje się ze wsparcia patronów. Każda suma
          pomaga w utrzymaniu strony.
        </p>
        <div className="support-amounts">
          {SUPPORT_SIZES.map((option) => (
            <a
              key={option.size}
              className={`support-amount${option.size === "medium" ? " support-amount--featured" : ""}`}
              href={supportHref(option.size)}
              target="_blank"
              rel="noopener noreferrer"
              title={`Postaw piwo za: ${option.pln} zł`}
            >
              <BeerIcon size={option.size} />
              <span className="support-amount__pln">{option.pln} zł</span>
            </a>
          ))}
        </div>
        <button type="button" className="support-dismiss" onClick={onClose}>
          Nie teraz
        </button>
      </div>
    </div>,
    document.body,
  );
}
